var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-forms-index" },
    [
      _c("vx-card", { attrs: { title: "Formulários" } }, [
        _c(
          "div",
          { staticClass: "configuration-forms-content" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8", lg: "6" } },
                  [
                    _c("select-suggestion", {
                      attrs: {
                        label: "Pessoa jurídica",
                        column: "company_name,trading_name,cnpj",
                        model: "LegalEntity",
                        appendClearOption: true,
                        placeholderText:
                          "Digite o nome ou CNPJ da pessoa jurídica",
                        itemTextFormat: _vm.legalEntityItemTextFormat
                      },
                      model: {
                        value: _vm.selectedLegalEntity,
                        callback: function($$v) {
                          _vm.selectedLegalEntity = $$v
                        },
                        expression: "selectedLegalEntity"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.legalEntityId
              ? _c("p", { staticClass: "text-muted mb-0 mt-3" }, [
                  _vm._v(
                    " Selecione uma pessoa jurídica para configurar os formulários. "
                  )
                ])
              : _vm._e(),
            _vm.legalEntityId &&
            !_vm.legalEntityDataReady &&
            !_vm.legalEntityLoadError
              ? _c("div", { staticClass: "configuration-forms-after-filter" }, [
                  _c("p", { staticClass: "text-muted mb-0" }, [
                    _vm._v(" Carregando dados da pessoa jurídica… ")
                  ])
                ])
              : _vm._e(),
            _vm.legalEntityId && _vm.legalEntityLoadError
              ? _c("div", { staticClass: "configuration-forms-after-filter" }, [
                  _c("p", { staticClass: "text-danger mb-0" }, [
                    _vm._v(
                      " Não foi possível carregar os dados desta pessoa jurídica. Selecione novamente ou tente mais tarde. "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.legalEntityId && _vm.legalEntityDataReady
              ? _c(
                  "div",
                  {
                    staticClass:
                      "configuration-forms-after-filter configuration-forms-tabs-area"
                  },
                  [
                    _c(
                      "vs-tabs",
                      { key: _vm.formsTabsKey, attrs: { color: _vm.colorx } },
                      [
                        _c(
                          "vs-tab",
                          { attrs: { label: "LGPD" } },
                          [
                            _c("privacy-request", {
                              attrs: {
                                legalEntityId: _vm.legalEntityId,
                                "legal-entity-record": _vm.loadedLegalEntity,
                                "hide-back-button": true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "vs-tab",
                          { attrs: { label: "Incidente" } },
                          [
                            _c("incident", {
                              attrs: {
                                legalEntityId: _vm.legalEntityId,
                                "legal-entity-record": _vm.loadedLegalEntity,
                                "hide-back-button": true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "vs-tab",
                          { attrs: { label: "Due Diligence" } },
                          [
                            _c("due-diligence", {
                              attrs: {
                                legalEntityId: _vm.legalEntityId,
                                "legal-entity-record": _vm.loadedLegalEntity,
                                "hide-back-button": true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "vs-tab",
                          { attrs: { label: "Intimidação Sistemática" } },
                          [
                            _c("systematic-intimidation", {
                              attrs: {
                                legalEntityId: _vm.legalEntityId,
                                "legal-entity-record": _vm.loadedLegalEntity,
                                "hide-back-button": true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "vs-tab",
                          { attrs: { label: "Formulário de Relato" } },
                          [
                            _c("reporting-channel", {
                              attrs: {
                                legalEntityId: _vm.legalEntityId,
                                "legal-entity-record": _vm.loadedLegalEntity,
                                "hide-back-button": true
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }